import React from 'react';
import Typography from '@material-ui/core/Typography';
import { StatusManager } from 'common/components/StatusManager';
import { EntityRoutes } from 'routes/constants';
import strings from 'strings';

import { PlainLink } from '../../shared';
import { DetailPanelLayout } from '../DetailPanelLayout';

import { FOOTER_COMPONENT_MAP } from './BulkEmailDetails.constants';
import { StyledBulkEmailDetails } from './BulkEmailDetails.styled';
import { DetailsPanelSkeleton } from './DetailsPanelSkeleton';

export const BulkEmailDetails = ({ bulk, entity, entityResult, pluralEntity }) => {
  const FooterComponent = FOOTER_COMPONENT_MAP[entity] || null;

  return (
    <DetailPanelLayout
      header={
        <>
          <Typography variant="subtitle1">
            {strings.bulkEmails.emailGenerator.headerLabel}
          </Typography>
          <PlainLink
            itemId={bulk?.id}
            linkProps={{
              type: 'local',
              url: EntityRoutes.SearchProjectsPreview,
              target: '_blank'
            }}
            aria-label="Search Project"
          >
            {bulk?.name} {bulk?.bulkableItems}
          </PlainLink>
        </>
      }
      body={
        <Typography variant="body2" gutterBottom>
          {strings.formatString(strings.bulkEmails.emailGenerator.craftingEmail, {
            pluralEntity
          })}
        </Typography>
      }
      footer={
        <StatusManager
          status={entityResult.state.status}
          slots={{
            Loading: <DetailsPanelSkeleton />,
            Error: (
              <Typography variant="body1" color="error">
                {entityResult.state.error}
              </Typography>
            )
          }}
        >
          <StyledBulkEmailDetails role="list">
            {(entityResult?.state?.results?.data || []).map(item => {
              if (!FooterComponent) return null;
              return <FooterComponent key={item.id} item={item} role="listitem" />;
            })}
          </StyledBulkEmailDetails>
        </StatusManager>
      }
    />
  );
};
